import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
import { supportLinks, loggedOutServiceLinks } from '../../../NavConfig';

const Sidebar = ({ show, handleClose, isImmi }) => {
   const Home = <NavLink to="/">Home</NavLink>

   const Services = <NavLink to="#">Services </NavLink>
   const Support = <NavLink to="#">Support</NavLink>
   const Login = <NavLink to="/login">Login</NavLink>
   const Register = <NavLink to="/register">Register</NavLink>

   // const Doctors = <NavLink to="/doctors">Doctors </NavLink>
   // const Shop = <NavLink to="/shop">Shop</NavLink>
   // const News = <NavLink to="/blogSidebar">News</NavLink>
   // const Pages = <a href="#">Pages</a>
   return (
      <>

         <div >
            <Offcanvas show={show} onHide={handleClose} placement='end' className='side__bar'>
               <Offcanvas.Header closeButton>
               </Offcanvas.Header>
               <Offcanvas.Body>
                  <Collapsible trigger={Home} 
                     triggerTagName="div"
                     triggerOpenedClassName="icon_close" 
                     triggerClassName="iconAdd iconAdd-single-item" 
                     open={false}
                     triggerDisabled={true}
                     >
                  </Collapsible>

                  
                  <Collapsible trigger={Support} 
                     triggerTagName="div"
                     triggerOpenedClassName="icon_close" 
                     triggerClassName="iconAdd" 
                     open={false}
                  >
                     <ul className="submenu">
                        {supportLinks.map((link, index) => (
                           <li key={index}><NavLink to={link.to}>{link.label}</NavLink></li>
                        ))}
                     </ul>
                  </Collapsible>




                  <Collapsible trigger={Services} 
                     triggerTagName="div"
                     triggerOpenedClassName="icon_close" 
                     triggerClassName="iconAdd" 
                     open={false}
                  >
                     <ul className="sidebar_sub_menu text-white mt-3">
                        {loggedOutServiceLinks.map((link, index) => (
                           <li key={index}><NavLink to={link.to}>{link.label}</NavLink></li>
                        ))}
                     </ul>
                  </Collapsible>
                  {!isImmi ? (
                     <>
                        <Collapsible trigger={Login} 
                           triggerTagName="div"
                           triggerOpenedClassName="icon_close" 
                           triggerClassName="iconAdd iconAdd-single-item" 
                           open={false}
                           triggerDisabled={true}
                        >
                        </Collapsible>

                        <Collapsible trigger={Register} 
                           triggerTagName="div"
                           triggerOpenedClassName="icon_close" 
                           triggerClassName="iconAdd iconAdd-single-item" 
                           open={false}
                           triggerDisabled={true}
                        >
                        </Collapsible>
                     </>
                  ) : null}
               </Offcanvas.Body>
            </Offcanvas>
         </div>
      </>
   );
};

export default Sidebar;